import type { EndpointMeta } from "@/apis/types";
import {
  createFetchAndHook,
  type FetchFactory,
  type HookFactory,
} from "@/shared/factories";
import { wsfScheduleApiMeta } from "../apiMeta";
import {
  type ScheduleAlertsInput,
  scheduleAlertsInputSchema,
} from "./shared/scheduleAlerts.input";
import {
  type AlertDetail,
  alertDetailSchema,
} from "./shared/scheduleAlerts.output";

/**
 * Metadata for the fetchScheduleAlerts endpoint
 */
export const scheduleAlertsMeta = {
  functionName: "fetchScheduleAlerts",
  endpoint: "/alerts",
  inputSchema: scheduleAlertsInputSchema,
  outputSchema: alertDetailSchema.array(),
  sampleParams: {},
  endpointDescription: "List all current schedule alerts.",
} satisfies EndpointMeta<ScheduleAlertsInput, AlertDetail[]>;

/**
 * Fetch function for retrieving all current schedule alerts
 */
const { fetch, useHook } = createFetchAndHook<
  ScheduleAlertsInput,
  AlertDetail[]
>({
  api: wsfScheduleApiMeta,
  endpoint: scheduleAlertsMeta,
  getCacheStrategy: () =>
    // eslint-disable-next-line @typescript-eslint/no-var-requires
    require("./shared/scheduleAlerts.endpoints").scheduleAlertsGroup
      .cacheStrategy,
});

/**
 * Fetch function for retrieving all current schedule alerts
 */
export const fetchScheduleAlerts: FetchFactory<
  ScheduleAlertsInput,
  AlertDetail[]
> = fetch;

/**
 * React Query hook for retrieving all current schedule alerts
 */
export const useScheduleAlerts: HookFactory<
  ScheduleAlertsInput,
  AlertDetail[]
> = useHook;
